<style scoped>
    [v-cloak] {
        display: none;
    }

    .title {
        font-size: 0.16rem;
        color: #333333;
        line-height: 0.16rem;
    }

    .wrap {
        width: 100%;
        padding-top: 0.1rem;
        background: #F4F8FF !important;
    }

    .no_list .top {
        width: 90%;
        background: #ffffff;
        border-radius: 6px;
        padding: 0.1rem 0rem;
        margin: 0.15rem auto;
    }

    .no_list .top .bg {
        width: 1.2rem;
        height: 1.2rem;
        position: absolute;
        right: 5%;
        top: 0.3rem;
    }

    .no_list .top img {
        width: 100%;
        height: 100%;
    }

    .no_list .top .title {
        width: 1.2rem;
        height: 0.58rem;
        margin-top: 0.2rem;
        margin-left: 0.15rem;
    }

    .no_list .top .desc {
        width: 65%;
        height: 0.42rem;
        font-size: 0.1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 0.14rem;
        color: #999999;
        margin-top: 0.2rem;
        margin-left: 0.15rem;
    }

    .no_list .top .apply_btn {
        width: 90%;
        height: 0.45rem;
        background: linear-gradient(132deg, #59A3FC 0%, #3C64F6 100%);
        box-shadow: 0rem 0.06rem 0.1rem 0rem #E4EEFA;
        border-radius: 0.25rem;
        margin: 0.2rem auto;
        text-align: center;
        line-height: 0.45rem;
    }

    .no_list .top .apply_btn span {
        font-size: 0.17rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
    }


    .no_list .bottom {
        width: 90%;
        background: #FFFFFF;
        border-radius: 6px;
        margin: 0px auto;

    }

    .no_list .bottom .tip {
        width: 3px;
        height: 12px;
        background: #486CFF;
        margin-top: 2px;
        margin-right: 5px;
    }

    .no_list .bottom .title {
        font-size: 0.14rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
    }

    .no_list .bottom .line {
        width: 100%;
        height: 1px;
        background: #EEEEEE;
    }

    .no_list .bottom p {
        font-size: 0.1rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 0.24rem;
    }

    .no_list .bottom p span {
        color: #EC614B;
    }

</style>

<template>
    <div class="wrap" id="app" v-cloak>
        <div class="no_list" v-if="pageShow">
            <div class="top">
                <div>
                    <div class="bg">
                        <img src="../../assets/img/newpage/recommend_result.png">
                    </div>
                    <div class="title">
                        <img src="../../assets/img/newpage/recommend_content.png">
                    </div>

                    <div class="desc" v-if="productId > 0" style="font-size: 0.13rem;line-height: 20px;color: #EC614B;">
                        根据您的资质，为您匹配其他通过率高的产品
                    </div>
                    <div class="desc" v-else>请等待初审通过的短信，若初审通过，2小时内会有专业顾问通过短信和电话与您沟通，请保持电话畅通！</div>

                    <div class="apply_btn" @click="loadApp"><span v-if="productId>0">前往申请</span>
                        <span v-else>查看审核进度</span></div>
                </div>
            </div>

            <div class="bottom">
                <div style="padding: 0.15rem 0.2rem;">
                    <div style="display: flex;">
                        <div class="tip"></div>
                        <div class="title">特别提醒</div>
                    </div>
                </div>
                <div class="line"></div>
                <div style="padding: 0.1rem 0.2rem;">
                    <p>1. 近期诈骗频发，<span>平台提醒用户注意保护个人隐私</span>，不相信以“银行卡错误”、“账户异常”、“征信差”等要求缴纳“手续费、保证金、解冻费“等，不点击陌生链接、不给陌生账户转账等，请提高安全意识，谨防诈骗。
                    </p>
                    <p>2.<span>致电人员属于平台合作的第三方金融机构，</span>产品信息以审核为准！</p>
                    <p>3. 如有需要请及时联系客服核实真伪，客服电话：0571-86076369</p>
                    <p>4. 借贷有风险，请根据您的实际情况理性借贷，避免逾期或过度借贷。</p>
                </div>
            </div>
        </div>

        <Loading :isShow="loading"></Loading>
    </div>

</template>

<script>
    import Loading from '@/components/loading';

    export default {
        components: {
            Loading
        },
        data() {
            return {
                pageShow: false,
                loading: false,
                productId: 0
            }
        },
        created() {
            this.util.title('申请成功');
            this.getApiAgencyFit();
        },
        methods: {
            getApiAgencyFit() {
                var os = localStorage.getItem("os");
                if (os && os == 1) { //只跳转安卓
                    this.loading = true;
                    this.$get("/app/api/v1/order/apiAgency/fit")
                        .then(res => {
                            this.loading = false;
                            this.pageShow = true;
                            if (res.code == 200) {
                                this.productId = res.data;
                            }
                        })
                        .catch(error => {
                            this.loading = false;
                        });
                } else {
                    this.pageShow = true;
                }
            },
            loadApp() {
                if (this.productId > 0) {
                    var pageUrl = "77xyPrefix/?id=" + this.productId + "&Page=3";
                    let param = {
                        pageUrl: pageUrl,
                    };
                    //跳到客户端页面——产品详情页面
                    try {
                        window.AppJs.toProductDetail(JSON.stringify(param)); //android
                    } catch (err) {

                    }
                } else {
                    window.location.href = "https://dc-app.yanhugame.com/loan/applyStatus?orderType=1&webRefresh=1";
                }
            },
        }
    }
</script>
